.room {
  --mobile-edge: #181410;
  background: radial-gradient(
    ellipse at 50% 42%,
    #173647 0%,
    #0b1b24 42%,
    #050b0f 72%,
    #020405 100%
  );
}

.crtCopy {
  position: absolute;
  z-index: 3;
  left: 31.75%;
  top: 13.8%;
  width: 39.6%;
  height: 38.2%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 3.1cqw;
  overflow: hidden;
  color: var(--green);
  text-shadow: 0 0 8px rgba(115, 217, 91, 0.5);
  box-shadow:
    0 0 2.3cqw rgba(99, 238, 102, 0.18),
    inset 0 0 2.8cqw rgba(99, 238, 102, 0.08);
  animation: phosphorFlicker 5.6s steps(1, end) infinite;
}

.crtCopy::before {
  content: '';
  position: absolute;
  z-index: -1;
  left: 0;
  right: 0;
  top: -18%;
  height: 12%;
  opacity: 0.13;
  background: linear-gradient(180deg, transparent, #9af77d, transparent);
  animation: phosphorSweep 4.8s linear infinite;
}

.crtCopy::after {
  content: '';
  position: absolute;
  inset: 0;
  pointer-events: none;
  opacity: 0.11;
  background: repeating-linear-gradient(0deg, transparent 0 4px, #8bea6d 5px);
}

.crtCopy > span {
  margin-bottom: 1.2cqw;
  color: #4a9d46;
  font-size: clamp(5px, 0.55cqw, 9px);
  letter-spacing: 1px;
}

.crtCopy h1 {
  margin: 0;
  color: #9af77d;
  font:
    400 clamp(14px, 1.9cqw, 30px) / 1.55 'Press Start 2P',
    monospace;
  text-transform: none;
}

.crtCopy h1 strong {
  color: #d0ffad;
  font-weight: 400;
}

.crtCopy p {
  min-height: 2.8em;
  margin: 1.2cqw 0 0;
  color: #6cc961;
  font:
    400 clamp(6px, 0.8cqw, 12px) / 1.55 'Press Start 2P',
    monospace;
}

.crtCopy p b {
  color: #d0ffad;
  font-weight: 400;
}
.crtCopy p i {
  display: inline-block;
  width: 0.62em;
  height: 1.2em;
  margin-left: 0.25em;
  vertical-align: -0.22em;
  background: #9af77d;
  animation: cursor 0.8s steps(1) infinite;
}

.crtCopy > small {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: auto;
  color: #4a9d46;
  font-size: clamp(4px, 0.48cqw, 7px);
  animation: prompt 1.1s steps(2) infinite;
}

.idlePrompt {
  position: absolute;
  z-index: 8;
  inset: 11% 6% 8%;
  display: grid;
  place-content: center;
  justify-items: center;
  gap: 1.2cqw;
  padding: 2cqw;
  border: 0.25cqw solid #5bbd52;
  color: #67bd5e;
  background: rgba(1, 8, 3, 0.94);
  text-align: center;
  box-shadow: inset 0 0 2.5cqw rgba(115, 217, 91, 0.12);
  animation: idlePromptIn 0.36s steps(4, end) both;
}

.idlePrompt span {
  font-size: clamp(5px, 0.6cqw, 9px);
}
.idlePrompt b {
  color: #cfffad;
  font-size: clamp(7px, 0.85cqw, 13px);
  line-height: 1.6;
  animation: idlePromptBlink 1.2s steps(2, end) infinite;
}

.steamSprite {
  position: absolute;
  z-index: 4;
  left: 16.2%;
  top: 26.5%;
  width: 14.5%;
  aspect-ratio: 362 / 724;
  background: url('/assets/v5-coffee-steam.png') no-repeat 0 0 / 600% 100%;
  animation: steamFrames 2.1s steps(1, end) infinite;
  filter: drop-shadow(0 0 3px rgba(234, 220, 174, 0.15));
  pointer-events: none;
}

.catSprite {
  position: absolute;
  z-index: 4;
  left: 72.3%;
  top: 42.2%;
  width: 25.5%;
  aspect-ratio: 543 / 724;
  background: url('/assets/v5-cat-breathing.png') no-repeat 0 0 / 400% 100%;
  animation: catFrames 5.6s steps(1, end) infinite;
  pointer-events: none;
}

@keyframes cursor {
  50% {
    opacity: 0;
  }
}
@keyframes prompt {
  50% {
    translate: 4px 0;
  }
}
@keyframes phosphorFlicker {
  0%,
  7%,
  9%,
  43%,
  45%,
  100% {
    filter: brightness(1);
  }
  8%,
  44% {
    filter: brightness(0.72);
  }
  72% {
    filter: brightness(1.08);
  }
}
@keyframes phosphorSweep {
  to {
    transform: translateY(980%);
  }
}
@keyframes catFrames {
  0%,
  16.6% {
    background-position: 0 0;
  }
  16.7%,
  33.3%,
  83.4%,
  100% {
    background-position: 33.333% 0;
  }
  33.4%,
  49.9%,
  66.7%,
  83.3% {
    background-position: 66.666% 0;
  }
  50%,
  66.6% {
    background-position: 100% 0;
  }
}
@keyframes steamFrames {
  0%,
  16.5% {
    background-position: 0 0;
  }
  16.6%,
  33.1% {
    background-position: 20% 0;
  }
  33.2%,
  49.7% {
    background-position: 40% 0;
  }
  49.8%,
  66.3% {
    background-position: 60% 0;
  }
  66.4%,
  82.9% {
    background-position: 80% 0;
  }
  83%,
  100% {
    background-position: 100% 0;
  }
}

@keyframes idlePromptIn {
  0% {
    opacity: 0;
    transform: scaleY(0.03);
  }
  55% {
    opacity: 1;
    transform: scaleY(0.03);
  }
  100% {
    opacity: 1;
    transform: scaleY(1);
  }
}
@keyframes idlePromptBlink {
  50% {
    opacity: 0.45;
  }
}

@media (max-width: 680px) {
  .crtCopy {
    left: 26.7%;
    top: 18.5%;
    width: 46.9%;
    height: 21.4%;
    padding: 15px;
  }
  .crtCopy > span {
    margin-bottom: 8px;
    font-size: 4px;
  }
  .crtCopy h1 {
    font-size: clamp(10px, 3vw, 14px);
    line-height: 1.48;
  }
  .crtCopy p {
    min-height: 2.6em;
    margin-top: 8px;
    font-size: clamp(5px, 1.6vw, 7px);
  }
  .crtCopy > small {
    margin-top: 4px;
    font-size: 4px;
  }
  .steamSprite {
    left: 12.5%;
    top: 31%;
    width: 14%;
  }
  .catSprite {
    left: 35.7%;
    top: 50.4%;
    width: 28%;
  }
}

@media (prefers-reduced-motion: reduce) {
  .crtCopy,
  .crtCopy::before,
  .crtCopy p i,
  .crtCopy > small,
  .idlePrompt,
  .idlePrompt b,
  .steamSprite,
  .catSprite {
    animation-duration: 0.01ms;
    animation-iteration-count: 1;
  }
}
